<div ng-controller="registerFilterConfigController as ctrl" class="modal-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>